// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.material-symbols-outlined {
  font-size: 14px;
}

.form-container .title {
  font-size: 1.5rem;
  margin-top: 0;
}

h1 {
  line-height: 1;
}`, "",{"version":3,"sources":["webpack://./src/app/main/pages/authentication/login/login.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;AACJ;;AAGI;EACI,iBAAA;EACA,aAAA;AAAR;;AAIA;EACI,cAAA;AADJ","sourcesContent":[".material-symbols-outlined {\n    font-size: 14px;\n}\n\n.form-container {\n    .title {\n        font-size: 1.5rem;\n        margin-top: 0;\n    }\n}\n\nh1 {\n    line-height: 1;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
